// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.solution-panel {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1607843137);
  opacity: 1;
  margin: 32px 25px;
  padding: 12px 0;
}
.solution-panel .solution-title {
  display: flex;
  justify-content: space-between;
  margin-left: 2%;
  width: 95%;
  font-family: "GothamBold", Arial, sans-serif;
  font-weight: bold;
  font-size: 20px;
  letter-spacing: 0px;
  color: #0066b2;
}
.solution-panel .solution-subtitle {
  display: flex;
  width: 95%;
  font-family: "Gotham", Arial, sans-serif;
  font-size: 14px;
  color: #0066b2;
  margin-left: 2%;
  margin-right: 2%;
}
.solution-panel .prop-label {
  font-family: "Gotham", Arial, sans-serif;
  font-weight: 100;
  font-size: 14px;
  text-align: left;
  font-weight: 100;
  letter-spacing: 0px;
  color: rgba(126, 126, 126, 0.8705882353);
  opacity: 1;
  margin: 0 0 0 0;
  padding: 0 0 0 0;
}
.solution-panel .prop-value {
  font-family: "Gotham", Arial, sans-serif;
  font-size: 14px;
  font-weight: 100;
  text-align: left;
  color: #000000;
  margin: 0 0 0 0;
  padding: 0 0 0 0;
}

.rows-of-3 {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-right: 2%;
  margin-left: 2%;
}
.rows-of-3 .box {
  flex: 0 0 33%;
  margin-top: 1%;
}

.coats-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 2%;
  margin-right: 2%;
  margin-left: 2%;
}

.add-to-workspace-container {
  margin-right: 2%;
}

.text-button {
  display: inline-block;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  cursor: pointer;
  outline: none;
  color: #0066b2;
  font-family: "GothamBold", Arial, sans-serif;
}
.text-button:hover {
  color: #0b2d71;
  box-shadow: inset 0 -2px 0 0 #0b2d71;
}

.highlighted {
  background-color: #faab18;
  font-weight: bold;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
